module.exports = __webpack_public_path__ + "img/orange-idcard.07a4670d.jpg";